export default __webpack_public_path__ + "static/media/interest-statements-product.adb4b211.svg";